module.exports = __webpack_public_path__ + "images/product-icon-6-years-warranty.73386c.svg";